export const datasource = 'rpm';
export const repomdXmlFileName = 'repomd.xml';
